<div class="modal-header">
  <h4 class="modal-title fw-normal">Upload File(s)</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="onCancel()"></button>
</div>

<div class="modal-body">
  @if (uploading()) {
  <groundworks-state-message type="loading" message="Uploading file(s)..." class="d-flex" />
  } @else {
  <form [formGroup]="uploadForm" class="d-flex flex-column gap-3">
    <div>
      <label class="form-label" for="groupIdSelect">Attachment Group</label>
      <select class="form-select" formControlName="groupId">
        @for (group of attachmentGroups(); track group.id) {
        <option [value]="group.id">{{ group.name }}</option>
        }
      </select>
    </div>

    <div>
      <label class="form-label" for="descriptionInput">Add description to all file(s)</label>
      <input type="text" class="form-control" placeholder="Please select" formControlName="description" />
    </div>
  </form>
  }
</div>

<div class="modal-footer">
  <button class="btn btn-primary" type="button" (click)="onUpload()" [disabled]="uploading()">
    Upload
  </button>
</div>
